export default "__VITE_ASSET__Bcxnk6td__"